import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisplayStatusAll = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 40,
			height: 40,
			rx: 4,
			stroke: "currentColor",
			strokeWidth: 3,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 10,
			width: 32,
			height: 4,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 19,
			width: 32,
			height: 4,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 28,
			width: 32,
			height: 4,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38,
			cy: 38,
			r: 3,
			fill: "currentColor"
		})
	]
});
export default SvgDisplayStatusAll;
